import Client from '../HttpClient';

const numbatUrl = '/gateway/numbat-api/api/vs/manage-config/sysParameter';
const list = (groupCode) => {
	return Client.get(`/admin/api/menu-item/group/${groupCode}`);
};

const listAll = () => {
	return Client.get(`/admin/api/menu-item/list-all`);
};
const listAllCloud = (merchantId, branchId) => {
	return Client.get(
		`${numbatUrl}/${merchantId}/${branchId}/menu-item/list-all`
	);
};
const listMenu = (groupCode) => {
	return Client.get(`/admin/api/menu-item/group/${groupCode}/with-index`);
};

const find = (code) => {
	return Client.get(`/admin/api/menu-item/${code}`);
};

const create = (payload) => {
	return Client.post(`/admin/api/menu-item`, payload);
};

const createForm = (payload) => {
	return Client.post(
		`/admin/api/menu-item/form`,
		payload,
		{},
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};

const update = (code, payload) => {
	return Client.put(`/admin/api/menu-item/${code}`, payload);
};

const updateForm = (code, payload) => {
	return Client.put(
		`/admin/api/menu-item/form/${code}`,
		payload,
		{},
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};

const remove = (Code) => {
	return Client.del(`/admin/api/menu-item/${Code}`);
};

const sort = (payload = []) => {
	return Client.put(`/admin/api/menu-item/arrange`, payload);
};

const batch = (payload) => {
	return Client.put(`/admin/api/menu-item/batch`, payload);
};

export default {
	listAll,
	list,
	listMenu,
	find,
	create,
	createForm,
	update,
	updateForm,
	remove,
	sort,
	batch,
	listAllCloud,
};
